export default "__VITE_ASSET__02d07d0d__"